import { Chip } from '@mui/material';
import PropTypes from 'prop-types';

function ExperimentStatus({ status }) {
    const getStatusColor = (status) => {
        switch (status) {
            case 'Completed':
                return 'success';
            case 'In Progress':
                return 'primary';
            case 'Backlog':
                return 'default';
            default:
                return 'default';
        }
    };

    return (
        <Chip
            label={status || 'Backlog'}
            color={getStatusColor(status)}
            size="small"
        />
    );
}

ExperimentStatus.propTypes = {
    status: PropTypes.string,
};

export default ExperimentStatus;
